import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotQuery(chatbotId: string | undefined) {
  const { user } = useAuth();
  const resolvedChatbotId = chatbotId?.trim() ?? '';
  const isEnabled = Boolean(user) && resolvedChatbotId.length > 0;

  return useQuery({
    queryKey: chatbotQueryKeys.chatbot(resolvedChatbotId),
    enabled: isEnabled,
    queryFn: () => chatbotService.getChatbot(resolvedChatbotId),
  });
}
